<template>
  <div id="app" :style="{ backgroundImage: `url(${background})` }">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      background: require(`@/assets/background.jpg`)
    }
  },
  mounted() {
    window.setDatas = function(key,value){      
      localStorage.setItem(key,JSON.stringify(value))
    }
    window.getDatas = function(key){
      return JSON.parse(localStorage.getItem(key))
    }
  }
}
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0;
  font-size: 15px !important;
  background-size: cover;
}

hr {
  width: 100%;
}
.demo-ruleForm{
  margin:50px;
}
del{
  color:red;
  text-decoration: none;
}
.el-form-item__content .Short {width: 150px;}
.el-form-item__content .Middle {width: 300px;}
.Long input{
  width: 400px;
}
.Long textarea{
  width: 400px;
}
form.demo-form{
  background:#fff;
  padding: 60px;
  border-radius: 10px;
  border:1px solid gray;
}
</style>